import React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import styles from "./CustomRadioGroup.module.css";

const CustomRadioGroup = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  options = [],
  row = true,
  disabled = false,
  required = false,
  error,
  helperText,
  className = "",
  labelClassName = "",
  size = "md",
  ...rest
}) => {
  const sizeMap = {
    sm: "small",
    md: "medium",
    lg: "medium",
  };

  return (
    <div className={`${styles.wrapper} ${className}`}>
      {label && (
        <span className={`${styles.groupLabel} ${labelClassName}`}>
          {label}
          {required && <span className={styles.required}>*</span>}
        </span>
      )}

      <RadioGroup
        name={name}
        value={value ?? ""}
        onChange={onChange}
        onBlur={onBlur}
        row={row}
        className={styles.radioGroup}
        {...rest}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            disabled={disabled || option.disabled}
            className={`${styles.formControl} ${styles[size]}`}
            control={
              <Radio
                size={sizeMap[size]}
                sx={{
                  color: error
                    ? "var(--color-danger)"
                    : "var(--color-border)",
                  "&.Mui-checked": {
                    color: "var(--color-primary)",
                  },
                }}
              />
            }
            label={
              <span
                className={`${styles.label} ${
                  disabled || option.disabled ? styles.labelDisabled : ""
                }`}
              >
                {option.label}
              </span>
            }
          />
        ))}
      </RadioGroup>

      {(error || helperText) && (
        <span
          className={`${styles.helperText} ${error ? styles.errorText : ""}`}
        >
          {error || helperText}
        </span>
      )}
    </div>
  );
};

export default CustomRadioGroup;
